import React, { useEffect, useMemo, useState } from "react";
import { Text, Dimensions, View } from "react-native";
import { SafeAreaProvider } from "react-native-safe-area-context";
import { NavigationContainer } from "@react-navigation/native";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import linking from "./app-navigator";
import LoginScreen from "../screens/AuthScreens/LoginScreen";
import RegisterScreen from "../screens/AuthScreens/RegisterScreen";
import HomeScreen from "../screens/HomeScreen/HomeScreen";
import VerifyOtp from "../screens/AuthScreens/VerifyOtp/VerifyOtp";
import Verification from "../screens/AuthScreens/VerifyOtp/Verification/Verification";
import UserProfileScreen from "../screens/UserProfileScreen/UserProfileScreen";
import TripDashbaord from "../screens/TripDashboard/TripDashbaord";
import Layout from "../screens/Layout/Layout";
import ShowTripInfo from "../screens/TripDetails/ShowTripInfo";
import ManageSchool from "../screens/ManageSchoolDetails/ManageSchool";
import { useDispatch, useSelector } from "react-redux";
import {
  randomBackgoundImage,
  setIsDrawerVisible,
} from "../store/slices/generalSlice";
import AllTrip from "../screens/Trip/AllTrip";
import ManageRole from "../screens/ManageRole/ManageRole";
import AllUsers from "../screens/All Users/AllUsers";
import NotificationScreen from "../screens/Notification/NotificationScreen";
import StudentRegister from "../screens/AuthScreens/StudentRegister";
import OrganizationProfile from "../screens/ManageSchoolDetails/Organization Profile/OrganizationProfile";
import PaymentHistory from "../screens/Payment History/PaymentHistory";
import RevenuePage from "../screens/AnalyticsRevenue/RevenuePage";
import TripsAnalysis from "../screens/TripAnalysis/TripsAnalysis";
import LandingPage from "../screens/LnadingPage/LandingPage";
import ForgotPassword from "../screens/AuthScreens/ForgotPassword";
import ResetPassword from "../screens/AuthScreens/ResetPassword";
import DesktopBackground from "../../assets/landingPage/landingBackground.webp";
import DesktopBackground1 from "../../assets/landingPage/landingBackground1.webp";
import DesktopBackground2 from "../../assets/landingPage/landingBackground2.webp";
import DesktopBackground3 from "../../assets/landingPage/landingBackground3.webp";
import DesktopBackground4 from "../../assets/landingPage/landingBackground4.webp";
import DesktopBackground5 from "../../assets/landingPage/landingBackground5.webp";
import DesktopBackground6 from "../../assets/landingPage/landingBackground6.webp";
import DesktopBackground7 from "../../assets/landingPage/landingBackground7.webp";
import DesktopBackground8 from "../../assets/landingPage/landingBackground8.webp";
import CompanyReview from "../screens/CompanyReview/CompanyReview";
import { get_token } from "../constant/apiUrl";
import { setLoginData } from "../store/slices/authSlice";

const AuthStack = () => {
  const Stack = createNativeStackNavigator();
  const { isDrawerVisible } = useSelector((state) => state.general);
  const LoggedInUser = useSelector((state) => state.auth.isLogin);
  const dispatch = useDispatch();
  const screen = Dimensions.get("window").width;
  const generateRandomImage = () => {
    const elements = [
      DesktopBackground,
      DesktopBackground1,
      DesktopBackground2,
      DesktopBackground3,
      DesktopBackground4,
      DesktopBackground5,
      DesktopBackground6,
      DesktopBackground7,
      DesktopBackground8,
    ];
    const randomNum = Math.floor(Math.random() * 9);
    // return 0 to 6  any random number
    return elements[randomNum];
  };
  useEffect(() => {
    dispatch(setIsDrawerVisible(screen >= 768 ? true : false));
    dispatch(randomBackgoundImage(generateRandomImage()));
    // set the token in store
    get_token().then((res) => {
      if (res) {
        const payload = {
          access: res,
          refresh: null,
        };
        dispatch(setLoginData(payload));
      }
    });
  }, []);

  const responsiveSidebar = useMemo(
    () =>
      screen < 768
        ? "100%"
        : !isDrawerVisible
        ? "100%"
        : Dimensions.get("window").width - 250,
    [screen, isDrawerVisible]
  );
  const screenOpacity = useMemo(() =>
    screen < 768 ? (isDrawerVisible ? 0.5 : 1) : (1)[(screen, isDrawerVisible)]
  );
  return (
    <>
      <SafeAreaProvider>
        <NavigationContainer
          linking={linking}
          fallback={<Text>Loading...</Text>}
        >
          <Stack.Navigator screenOptions={{ headerShown: false }}>
            {LoggedInUser ? (
              <Stack.Screen name="user">
                {() => (
                  <View style={{ display: "flex", flexDirection: "row" }}>
                    <Layout />
                    <View
                      style={{
                        width: responsiveSidebar,
                        opacity: screenOpacity,
                        minHeight: "100%",
                      }}
                    >
                      <Stack.Navigator>
                        <Stack.Screen
                          name="Dashboard"
                          options={{ headerShown: false }}
                          component={TripDashbaord}
                        />
                        <Stack.Screen
                          name="ShowTripInfo"
                          options={
                            screen >= 768
                              ? {
                                  title: "Trip information",
                                  headerShown: true,
                                }
                              : { headerShown: false }
                          }
                          component={ShowTripInfo}
                        />
                        <Stack.Screen
                          name="Profile"
                          options={{ headerShown: false }}
                          component={UserProfileScreen}
                        />
                        <Stack.Screen
                          name="Trip"
                          options={{ headerShown: false }}
                          component={AllTrip}
                        />
                        <Stack.Screen
                          name="Manage_School_Details"
                          options={{ headerShown: false }}
                          component={ManageSchool}
                        />
                        <Stack.Screen
                          name="Role_Management"
                          options={{ headerShown: false }}
                          component={ManageRole}
                        />
                        <Stack.Screen
                          name="All_User"
                          options={{ headerShown: false }}
                          component={AllUsers}
                        />
                        <Stack.Screen
                          name="Notification"
                          options={{ headerShown: false }}
                          component={NotificationScreen}
                        />
                        <Stack.Screen
                          name="Organization_Profile"
                          options={{ headerShown: false }}
                          component={OrganizationProfile}
                        />
                        <Stack.Screen
                          name="Payment_History"
                          options={{ headerShown: false }}
                          component={PaymentHistory}
                        />
                        <Stack.Screen
                          name="Analytics"
                          options={{ headerShown: false }}
                          component={RevenuePage}
                        />
                        <Stack.Screen
                          name="Analytics_Trip"
                          options={{ headerShown: false }}
                          component={TripsAnalysis}
                        />
                        <Stack.Screen
                          name="Company_Review"
                          options={{ headerShown: false }}
                          component={CompanyReview}
                        />
                      </Stack.Navigator>
                    </View>
                  </View>
                )}
              </Stack.Screen>
            ) : (
              <React.Fragment>
                <Stack.Screen
                  name="Home"
                  component={HomeScreen}
                  options={{
                    title: "Maroon Migrates - Tourism with Difference, Purpose",
                  }}
                />
                <Stack.Screen name="Register" component={RegisterScreen} />
                <Stack.Screen name="Login" component={LoginScreen} />
                <Stack.Screen name="Reset_Password" component={ResetPassword} />
                <Stack.Screen
                  name="ForgotPassword"
                  component={ForgotPassword}
                />
                <Stack.Screen
                  name="StudentRegister"
                  component={StudentRegister}
                />
                <Stack.Screen name="VerifyOtp" component={VerifyOtp} />
                <Stack.Screen name="Verification" component={Verification} />
                <Stack.Screen
                  name="Trip"
                  options={{ headerShown: false }}
                  component={AllTrip}
                  initialParams={{ isPublic: true }}
                />
                <Stack.Screen
                  name="ShowTripInfo"
                  options={
                    screen >= 768
                      ? {
                          title: "Trip information",
                          headerShown: true,
                        }
                      : { headerShown: false }
                  }
                  component={ShowTripInfo}
                />
              </React.Fragment>
            )}
            <Stack.Screen name="About Us" component={LandingPage} />
          </Stack.Navigator>
        </NavigationContainer>
      </SafeAreaProvider>
    </>
  );
};

export default AuthStack;
